var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSleeperBirth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2235",
    "data-name": "Group 2235",
    transform: "translate(19902 17410.721)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1113",
    "data-name": "Rectangle 1113",
    width: 24,
    height: 24,
    transform: "translate(-19902 -17410.721)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1933",
    "data-name": "Group 1933",
    transform: "translate(-19900.891 -17409.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M-788.129-123.736c-.033.07-.06.143-.1.209q-1.075,1.808-2.152,3.614c-.036.061-.07.123-.12.211h2.659v1.288h-4.945l2.394-4.021h-2.124v-1.3Z",
    transform: "translate(809.819 123.736)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M-1082.864-79.512a7.992,7.992,0,0,0-3.464,5.869,7.759,7.759,0,0,0,1.374,5.341,7.821,7.821,0,0,0,5.107,3.343,7.985,7.985,0,0,0,5.98-1.173,10.2,10.2,0,0,1-11.506,6.881,10.19,10.19,0,0,1-8.241-12.124A10.16,10.16,0,0,1-1082.864-79.512Z",
    transform: "translate(1093.831 81.151)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M-895.628-31.08v-1.3h3.982l-1.846,3.1h1.793v1.293h-4.077l1.842-3.1Z",
    transform: "translate(906.955 36.711)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M-813.255,67.26l-1.158,1.948h1.194v1.3H-816.7l1.159-1.952h-1.037V67.26Z",
    transform: "translate(832.443 -57.326)",
    fill: "#586973"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleeperBirth);
export default __webpack_public_path__ + "static/media/sleeperBirth.43e882cb.svg";
export { ForwardRef as ReactComponent };